// Module: tasks — «المهام» (HANDOFF §3: مهامي · كل المهام · المنجزة → board
// tasks/board). Flag erp.tasks, every role (HANDOFF §9). Scopes are
// sub-paths (/tasks/mine · /tasks/all · /tasks/all/overdue · /tasks/done) so
// each menu row has its own active state («متأخّرة» nests under «كل المهام»
// so the rail/menu keep their context); the open task rides on `?task=<id>`.
// /tasks itself lands on «مهامي» for staff and «كل المهام» for manager+.

import { ListChecks } from 'lucide-react';
import { Navigate } from 'react-router-dom';
import { defineModule } from '@/app/module-types';
import { useErp } from '@/app/erp-context';

function TasksIndex() {
  const { role } = useErp();
  return <Navigate to={role === 'staff' ? '/tasks/mine' : '/tasks/all'} replace />;
}

export default defineModule({
  key: 'tasks',
  label: 'المهام',
  icon: ListChecks,
  flag: 'erp.tasks',
  minRole: 'staff',
  rail: 'tasks',
  routes: [
    { path: '/tasks', element: <TasksIndex /> },
    { path: '/tasks/all', lazy: () => import('./screens/TasksBoard').then((m) => ({ Component: m.AllTasksRoute })) },
    { path: '/tasks/mine', lazy: () => import('./screens/TasksBoard').then((m) => ({ Component: m.MyTasksRoute })) },
    { path: '/tasks/all/overdue', lazy: () => import('./screens/TasksBoard').then((m) => ({ Component: m.OverdueTasksRoute })) },
    { path: '/tasks/done', lazy: () => import('./screens/TasksDone').then((m) => ({ Component: m.DoneTasksRoute })) },
  ],
  menu: [
    { key: 'mine', label: 'مهامي', to: '/tasks/mine' },
    { key: 'all', label: 'كل المهام', to: '/tasks/all' },
    { key: 'done', label: 'المنجزة', to: '/tasks/done' },
  ],
});
